import { Box, Grid, Container, Stack } from '@mantine/core';
import { IconSend, IconFileText, IconChartPie } from '@tabler/icons-react';
import { PageHeader } from '../components/common/PageHeader';
import StatCard from '../components/dashboard/StatCard';
import { useJobs } from '../api/jobs';

export default function AnalyticsPage() {
    const { data: jobs } = useJobs();

    return (
        <Container size="xl" py="xl">
            <Stack gap="xl">
                <PageHeader
                    title="Analytics"
                    subtitle="Insights into your job search progress."
                />
                <Grid>
                    <Grid.Col span={{ base: 12, sm: 4 }}>
                        <StatCard
                            label="TOTAL APPLICATIONS"
                            value={jobs?.length.toString() || '0'}
                            trend="+2 this week"
                            icon={<IconSend size="1.2rem" />}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, sm: 4 }}>
                        <StatCard
                            label="RESUMES GENERATED"
                            value="0"
                            trend="+5 this week"
                            icon={<IconFileText size="1.2rem" />}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, sm: 4 }}>
                        <StatCard
                            label="RESPONSE RATE"
                            value="0%"
                            trend="+5% vs last month"
                            icon={<IconChartPie size="1.2rem" />}
                        />
                    </Grid.Col>
                </Grid>
            </Stack>
        </Container>
    );
}
